import {atomWithStorage} from 'jotai/utils'
import {createMigrationStorage} from '../migration-storage'

export const currentUserState = atomWithStorage<any>(
  'currentUser',
  null,
  createMigrationStorage('currentUser'),
  {getOnInit: true}
)

export const currentLendingUserState = atomWithStorage<any>(
  'currentLendingUser',
  null,
  createMigrationStorage('currentLendingUser'),
  {getOnInit: true}
)
